<template>
  <div>
    <b-modal
      id="modal-editTopicSNPMB"
      ref="modal-editTopicSNPMB"
      size="lg"
      hide-header-close hide-footer hide-header scrollable no-close-on-backdrop>
      <div class="mx-4">
        <h3 class="text-center my-2 mb-4 fw-bolder">Edit Materi</h3>
        <!-- Topic Name -->
        <h5 class="fw-bold">Topik</h5>
        <input class="inputInsert" v-model="getDetail.topic_name" type="text" placeholder="Input judul materi">
        <!-- Detail Topic -->
        <h5 class="fw-bold mt-3">Detail</h5>
        <vue-editor :key="getDetail.id_topic" useCustomImageHandler @image-added="handleImageEdit" v-model="getDetail.detail_topic"></vue-editor>
        <div class="text-center mt-3">
          <button class="btn cancelBtn" @click="cancelEdit()">Batalkan</button>
          <button class="btn editBtn" @click="btnSave()">Simpan</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import imgConvert from '../helper/base64'
import alert from '../helper/alert'
import mathJax from '../helper/mathjax'
export default {
  data () {
    return {
      serverURL: process.env.VUE_APP_URL,
      imgEdit: []
    }
  },
  mixins: [alert, mathJax, imgConvert],
  components: {
    VueEditor
  },
  computed: {
    ...mapGetters({
      getDetail: 'topic/getDetail',
      getToken: 'auth/getToken',
      getId: 'auth/getId'
    })
  },
  methods: {
    ...mapActions({
      uploadImageTopic: 'topic/uploadImageTopic',
      actionEdit: 'topic/actionEdit',
      actionTopicSNPMB: 'topic/actionTopicSNPMB'
    }),
    topic () {
      const data = {
        category_id: this.getDetail.category_id
      }
      this.actionTopicSNPMB(data)
    },
    async handleImageEdit (file, Editor, cursorLocation, resetUploader) {
      file = await this.getBase64(file)
      const data = {
        image: file
      }

      this.uploadImageTopic(data).then(result => {
        const url = result.data // Get url from response
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
        this.imgEdit.push(url)
      }).catch({})
    },
    async cancelEdit () {
      if (this.imgEdit) {
        const images = this.imgEdit
        for (let i = 0; i < images.length; i++) {
          const data = {
            image: images[i]
          }
          await axios({
            url: `${this.serverURL}/v1/topicImage`,
            method: 'DELETE',
            data: data,
            headers: { token: this.getToken }
          })
            .then({})
            .catch({})
        }
        this.imgEdit = []
      }
      this.hideModal()
    },
    async btnSave () {
      const editImg = this.imgEdit
      const dataImageEdit = editImg.filter((el) => {
        return this.getDetail.detail_topic.includes(el)
      })
      const detailImg = this.getDetail.image.split(',')
      const detailEditImg = detailImg.filter((el) => {
        return this.getDetail.detail_topic.includes(el)
      })
      const data = {
        id_topic: this.getDetail.id_topic,
        category_id: this.getDetail.category_id,
        topic_name: this.getDetail.topic_name,
        detail_topic: this.getDetail.detail_topic,
        id_topic_updater: this.getId,
        image: dataImageEdit.concat(detailEditImg).join()
      }

      await this.actionEdit(data).then(async (response) => {
        if (this.getDetail.image || this.getDetail.image !== 'image') {
          const qtn = this.getDetail.image.split(',')
          const Imagefiltered = qtn.filter((el) => {
            return !this.getDetail.detail_topic.includes(el)
          })
          Imagefiltered.map(async (el) => {
            if (el) {
              const dataDelete = {
                image: el
              }
              await axios({
                url: `${this.serverURL}/v1/topicImage`,
                method: 'DELETE',
                data: dataDelete,
                headers: { token: this.getToken }
              })
                .then({})
                .catch({})
            }
          })
        } else {}
        // handleImageEdit
        if (this.imgEdit) {
          const images = this.imgEdit
          const dataFiltered = images.filter((el) => {
            return !this.getDetail.detail_topic.includes(el)
          })
          dataFiltered.map(async (el) => {
            if (el) {
              const imgDelete = {
                image: el
              }
              await axios({
                url: `${this.serverURL}/v1/topicImage`,
                method: 'DELETE',
                data: imgDelete,
                headers: { token: this.getToken }
              })
                .then({})
                .catch({})
            }
          })
        }
        this.hideModal()
        this.topic()
        this.imgEdit = []
        this.ToastSuccess('Data berhasil diperbaharui.')
      }).catch(() => {})
    },
    hideModal () {
      this.$refs['modal-editTopicSNPMB'].hide()
    }
  }
}
</script>
